import React, { useState, useEffect } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";

import ChartItem from "./ChartItem";
import MasterFilter from "./MasterFilter";
import { CA_GEO_HIERARCHY_ELEMENTS, CA_RECOMMENDATION_ELEMENTS, CHART_ITEMS, CHART_ITEMS_FOR_EXCEL, MASTER_FILTER_ROWS } from "../constants";
import { getEnityNameForCAband } from "../utils";
import { MyFilters } from "../../dashboard/components/FilterModal/MyFilters";
import Portal from "../../common/components/Portal";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../dashboard/actions";
import ConfirmationModal from "../../common/components/ConfirmationModal";

const isExecutiveSummaryTile = (key, tile = {}) => !!tile?.is_building_exec_sum;

const normalizeFilterValues = values => {
    if (values === undefined || values === null || values === "") return [];
    return (Array.isArray(values) ? values : [values]).map(value => String(value)).sort();
};

const ChartSection = ({
    getSmartChartMasterFilterDropDown,
    projectsDropdownData = [],
    projectId,
    setSmartChartData,
    currentBand,
    currentBandIndex,
    masterFilterList,
    openChartItemConfigModal,
    chartSectionData,
    chartKeys = [],
    copyChartSectionData,
    entity,
    selectedClient,
    toggleImageListForBandModal,
    toggleImageBandDeleteConfirmationModal,
    editImageBand,
    isEdit,
    updatePageBreakConfig,
    isExcelExport,
    isSkeletonView,
    requiredFields,
    filterOpen = false,
    setFilterOpen,
    handleShowDocPreview,
    isPreviewDocLoading,
    selectedDocPreview,
    updateDocHeaderConfig,
    entireChartData = {},
    openExecutiveSummaryHierarchyConfig
}) => {
    const [chartData, setChartData] = useState([]);
    const [rowConstructArray, setRowConstructArray] = useState([]);
    const [year, setYear] = useState("");
    const dispatch = useDispatch();
    const [smartChartFilterName, setSmartChartFilterName] = useState(chartSectionData?.filter_label || {});
    const [isDataReady, setIsDataReady] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [headerConfirmationModal, setHeaderConfirmationModal] = useState(false);
    const [clearLocalFilters, setClearLocalFilters] = useState(null);

    const {
        filterFields,
        masterFilterList: dashboardMasterFilterList,
        getDashboard,
        getBuildingTypeFilter
    } = useSelector(state => state.dashboardReducer);
    const [smartChartSectionData, setSmartChartSectionData] = useState(chartSectionData?.mfilter || {});
    const [isMasterFilterSubmit, setIsMasterFilterSubmit] = useState(false);
    const [temporaryMasterFilterData, setTemporaryMasterFilterData] = useState(false);
    useEffect(() => {
        setSmartChartFilterName(chartSectionData?.filter_label);
    }, [chartSectionData]);
    useEffect(() => {
        setSmartChartSectionData(chartSectionData?.mfilter);
        setChartItemData(entity);
        if (Object?.keys(chartSectionData?.mfilter)?.length > 0) {
            Object.entries(chartSectionData?.mfilter)?.forEach(([key, value]) => {
                if (key === "building_types" && isEdit && !isMasterFilterSubmit) {
                    const { [key]: omit, ...rest } = { ...chartSectionData?.mfilter };
                    dispatch(actions.getMasterFilter(rest, key));
                    setIsMasterFilterSubmit(null);
                } else {
                    if (isMasterFilterSubmit) {
                        const names =
                            Array.isArray(value) && value.length > 0
                                ? dashboardMasterFilterList?.building_types?.filter(ms => value.includes(ms.id))?.map(item => item.name) || []
                                : [];
                        setSmartChartSectionData({ ...chartSectionData?.mfilter, building_types: names });
                    }
                }
            });
        }
    }, [chartSectionData, isExcelExport]);
    useEffect(() => {
        if (filterOpen) {
            setIsMasterFilterSubmit(false);
            setClearLocalFilters(false);
            if (Object.keys(chartSectionData?.mfilter)?.includes("building_types")) {
                if (Object?.keys(chartSectionData?.mfilter)?.length > 0) {
                    Object.entries(chartSectionData?.mfilter)?.forEach(([key, value]) => {
                        if (key === "building_types") {
                            const names =
                                dashboardMasterFilterList?.building_types?.filter(ms => value.includes(ms.id))?.map(item => item.name) || {};
                            setSmartChartSectionData({ ...chartSectionData?.mfilter, building_types: names });
                        }
                    });
                }
            }
            setIsDataReady(true);
        } else {
            setIsDataReady(false);
        }
    }, [filterOpen]);
    // useEffect(() => {
    //     if (Object?.keys(chartSectionData?.mfilter)?.length > 0) {
    //         Object.entries(chartSectionData?.mfilter)?.forEach(([key, value]) => {
    //             if (key === "building_types") {
    //                 const names = dashboardMasterFilterList?.building_types?.filter(ms => value.includes(ms.id))?.map(item => item.name) || {};
    //                 setSmartChartSectionData({ ...chartSectionData?.mfilter, building_types: names });
    //             }
    //         });
    //     }
    // }, [dashboardMasterFilterList]);
    useEffect(() => {
        if (getDashboard && getDashboard.years) {
            let graphData = getDashboard.years;

            let yearValues = [];
            for (let i = graphData.start; i <= graphData.end; i++) yearValues.push(i);

            setYear(yearValues);
        }
    }, [getDashboard]);
    useEffect(() => {
        if (isMasterFilterSubmit) {
            MasterFilterSubmit(isMasterFilterSubmit, clearLocalFilters ?? false);
        }
    }, [isMasterFilterSubmit, dashboardMasterFilterList, clearLocalFilters]);

    const setChartItemData = (entity = "project") => {
        let chartDataArray = [];
        let chartItemList = { ...chartSectionData.type };
        let copyChartItemList = copyChartSectionData?.type || {};
        let entityKeys = Object.keys(CHART_ITEMS[entity]);
        chartKeys.forEach(chartItem => {
            const tile = chartItemList?.[chartItem] || copyChartItemList?.[chartItem] || {};
            const isExecSumHierarchy = !!tile?.is_building_exec_sum;
            const isExecSumParent = !!tile?.exec_sum_parent_wrapper;
            const execSumBandValues = (() => {
                const b = tile.band;
                if (!b) return [];
                return Array.isArray(b) ? b : Object.values(b);
            })();
            const flatChild = isExecSumHierarchy && !isExecSumParent && execSumBandValues?.length === 1 ? execSumBandValues?.[0] : null;
            const isExecSumFlatImage = flatChild?.band_type === "image";
            const isExecSumFlatText = flatChild?.band_type === "text";
            chartDataArray.push({
                name:
                    chartItem.includes("user_doc") || chartItem.includes("image_doc")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || chartItem
                        : chartItem.includes("list_image")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "Image Band"
                        : chartItem.includes("multi_recommendation")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "Recommendation Summary"
                        : chartItem.includes("normal_recom")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "Recommendation Table"
                        : chartItem.includes("recom_onepager")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "Recommendation One Pager"
                        : chartItem.includes("asset-onepager")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "Asset One Pager"
                        : chartItem.includes("building_report")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "BBI/Stoplight Chart"
                        : chartItem.includes("addition_report")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "BAI/Stoplight Chart"
                        : chartItem.includes("site_report")
                        ? chartItemList[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "BSI/Stoplight Chart"
                        : chartItem.includes("memo_field")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "Text Band"
                        : chartItem.includes("filter_report1")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "Master Filters"
                        : chartItem.includes("table_of_contents")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "Table of Contents"
                         : chartItem.includes("sorted_recom")
                        ? chartItemList?.[chartItem]?.band1?.name || copyChartItemList?.[chartItem]?.band1?.name || "Sorted Recommendation"
                        : chartItem.includes("multisystem_")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "System"
                        : chartItem.includes("building_report_")
                        ? chartItemList[chartItem]?.name || copyChartItemList?.[chartItem]?.name || "BBI/Stoplight Chart"
                        :  !entityKeys.includes(chartItem) && !isExecSumHierarchy
                        ? getComparativeAnalysisBandName(chartItem, chartItemList || copyChartItemList) || chartItem
                        : isExecSumHierarchy
                        ? tile?.name || copyChartItemList?.[chartItem]?.name || chartItem
                        :  chartItem,
                isSelected: chartItemList.hasOwnProperty(chartItem),
                defaultValue: isExcelExport
                    ? CHART_ITEMS_FOR_EXCEL[entity][chartItem.includes("multisystem_") ? "system" : chartItem]?.defaultValue
                    : CHART_ITEMS[entity][chartItem.includes("multisystem_") ? "system" : chartItem]?.defaultValue || "",
                // isVisible: CHART_ITEMS[entity][chartItem]?.isVisible,
                totalChartCount: chartItem.includes("list_image")
                    ? chartItemList?.[chartItem]?.data?.length || 0
                    : isExecSumFlatImage
                    ? flatChild?.data?.length || 0
                    :chartItem.includes("multi_recommendation")
                    ? chartItemList?.[chartItem]?.recommendations?.length || chartItemList?.[chartItem]?.number_of_recom || 0
                    : chartItem.includes("normal_recom") || chartItem.includes("recom_onepager") || chartItem.includes("asset-onepager")
                    ? chartItem.includes("asset-onepager")
                        ? chartItemList?.[chartItem]?.band1?.mfilter?.asset_ids?.length || 0
                        : chartItemList?.[chartItem]?.band1?.mfilter?.recommendations?.length ||
                          chartItemList?.[chartItem]?.band1?.number_of_recom ||
                          0
                    : (chartItemList?.[chartItem]?.summary_view?.chart_type?.length || 0) +
                      (chartItemList?.[chartItem]?.detailed_view?.chart_type?.length || 0),
                isUserDoc: chartItem.includes("user_doc") || chartItem.includes("image_doc") ? true : false,
                isImage: chartItem.includes("image_doc") ? true : false,
                isImageBand: chartItem.includes("list_image") || isExecSumFlatImage ? true : false,
                isFilterReport: chartItem.includes("filter_report1") ? true : false,
                docKey: chartItem,
                hasConfig:
                    CHART_ITEMS[entity]?.[chartItem.includes("multisystem_") ? "system" : chartItem]?.hasConfig ||
                    chartItem.includes("list_image") ||
                    chartItem.includes("multi_recommendation") ||
                    chartItem.includes("normal_recom") ||
                    chartItem.includes("recom_onepager") ||
                    chartItem.includes("asset-onepager") ||
                    chartItem.includes("building_report") ||
                    chartItem.includes("addition_report") ||
                    chartItem.includes("site_report") ||
                    (isExecSumHierarchy && (isExecSumParent || isExecSumFlatImage))
                        ? true
                        : false,
                config: CHART_ITEMS[entity]?.[chartItem.includes("multisystem_") ? "system" : chartItem]?.config || null,
                entityIcon: isExecSumParent
                    ? "smart-chart-exec-sum-folder.svg"
                    : isExecSumFlatText
                      ? "clipboard-text.svg"
                      : getEntityIcon(chartItem.includes("multisystem_") ? "system" : chartItem, entityKeys),
                isIndividualBuilding: chartItemList?.[chartItem]?.hasOwnProperty("is_indv_bld"),
                isCAband:
                    !chartItem.includes("list_image") &&
                    !chartItem.includes("image_doc") &&
                    !chartItem.includes("user_doc") &&
                    !chartItem.includes("multi_recommendation") &&
                    !chartItem.includes("normal_recom") &&
                    !chartItem.includes("recom_onepager") &&
                    !chartItem.includes("asset-onepager") &&
                    !chartItem.includes("memo_field") &&
                    !chartItem.includes("building_report") &&
                    !chartItem.includes("addition_report") &&
                    !chartItem.includes("site_report") &&
                    !chartItem.includes("multisystem_") &&
                    !isExecSumHierarchy &&
                    !entityKeys.includes(chartItem),
                isMultipleRecommendation: chartItem.includes("multi_recommendation") ? true : false,
                isRecommendation: chartItem.includes("normal_recom") ? true : false,
                tileData: chartItemList?.[chartItem] || copyChartItemList?.[chartItem] || {},
                innerHierarchyNodeId: flatChild?.band_id ?? null,
                flatBandData: flatChild || null,
                isExecutiveSummaryParent: isExecSumParent,
                isOnePager: chartItem.includes("recom_onepager") || chartItem.includes("asset-onepager") ? true : false,
                isAssetOnePager: chartItem?.includes("asset-onepager"),
                isBbi: chartItem.includes("building_report"),
                isBai: chartItem.includes("addition_report"),
                isBsi: chartItem.includes("site_report"),
                isMemo: chartItem.includes("memo_field") || isExecSumFlatText,
                isTOC: chartItem.includes("table_of_contents"),
                isDynamicSystem: chartItem.includes("multisystem_"),
                isSortedRecom: chartItem.includes("sorted_recom"),
                isDynamicBBI: chartItem.startsWith("building_report") && chartItem !== "building_report1",
                isDynamicBSI: chartItem.startsWith("site_report") && chartItem !== "site_report1",
                isDynamicBAI: chartItem.startsWith("addition_report") && chartItem !== "addition_report1",
                hasPageBreak: chartItem === "energy_band" || chartItem.includes("list_image") || isExecSumFlatImage
            });
        });
        if (chartDataArray.length) {
            let totalRows = chartDataArray.length / 4 + (chartDataArray.length % 4 ? 1 : 0);
            let tempRowConstructArray = [];
            for (let i = 1; i <= totalRows; i++) {
                tempRowConstructArray.push(i);
            }
            setRowConstructArray([...tempRowConstructArray]);
        }
        setChartData([...chartDataArray]);
    };
    const getComparativeAnalysisBandName = (chartItem = "") => {
        if (!chartItem) return "";

        const elements = [...CA_RECOMMENDATION_ELEMENTS, ...CA_GEO_HIERARCHY_ELEMENTS];
        const labelMap = Object.fromEntries(elements.map(({ key, label }) => [key, label]));

        const rawParts = chartItem.split("_");
        const parts = [];
        for (let i = 0; i < rawParts.length; i++) {
            if (rawParts[i] === "fci" && rawParts[i + 1] === "benchmarking") {
                parts.push("fci_benchmarking");
                i++;
            } else {
                parts.push(rawParts[i]);
            }
        }

        parts.pop();
        const lastKey = parts.pop();

        const capitalize = w => w.charAt(0).toUpperCase() + w.slice(1);
        const getLabel = k => labelMap[k] || capitalize(k);

        const formatted = parts.map(getLabel);
        const lastLabel = getLabel(lastKey);

        if (lastLabel === "Breakdownyears") {
            return `Comparative Analysis Band (Cost by ${formatted.join(", ")} and Year Grouping)`;
        }
        return `Comparative Analysis Band (${formatted.join(", ")} & ${lastLabel})`;
    };

    const getEntityIcon = (chartItem, entityKeys = []) => {
        if (chartItem.includes("memo_field")) {
            return "clipboard-text.svg";
        }
        if (chartItem.includes("user_doc")) {
            return "file-type-standard.svg";
        }
        if (chartItem.includes("image_doc") || chartItem.includes("list_image")) {
            return "smart-chart-image-item.svg";
        }
        if (chartItem?.includes("recom_onepager") || chartItem?.includes("asset-onepager")) {
            return "sm-charts-one-pager.svg";
        }
        if (
            chartItem === "sorted_recom" ||
            chartItem === "energy_band" ||
            chartItem === "water_band" ||
            chartItem === "multi_recommendation" ||
            chartItem === "normal_recom" ||
            chartItem === "asset_band" ||
            chartItem.includes("building_report") ||
            chartItem.includes("addition_report") ||
            chartItem.includes("site_report") ||
            chartItem.includes("filter_report1") ||
            !entityKeys.includes(chartItem) ||
            isExcelExport ||
            chartItem === "table_of_contents"
        ) {
            return "sm-charts-table-blue-icon.svg";
        }
        return "smart-chart-chart-icon-item.svg";
    };
    const filteredData = Object.keys(MASTER_FILTER_ROWS)
        .filter(key => key !== "project")
        .reduce((obj, key) => {
            obj[key] = MASTER_FILTER_ROWS[key];
            return obj;
        }, {});
    const getSystemChartParams = dashboardFilterParams => {
        let params = {};
        let buildingTypeData = getBuildingTypeFilter?.building_types || dashboardMasterFilterList?.building_types;
        const building_type_ids =
            buildingTypeData?.filter(item => dashboardFilterParams?.building_types?.some(elm => elm === item.name)).map(item => item.id) || [];
        if (building_type_ids?.length) {
            params = building_type_ids;
        }
        return params;
    };
    const hasBuildingFilterChanged = filterObjects => {
        const currentBuildingIds = normalizeFilterValues(chartSectionData?.mfilter?.building_ids);
        const nextBuildingIds = normalizeFilterValues(filterObjects?.building_ids);
        return JSON.stringify(currentBuildingIds) !== JSON.stringify(nextBuildingIds);
    };
    const MasterFilterSubmit = (filterObjects, applyMasterToLocalFilter) => {
        if (filterObjects) {
            const { filters, top_n, ...rest } = filterObjects;
            filterObjects = {
                ...rest,
                ...(filters && { filters }),
                ...(top_n && { top_n })
            };
        }
        const removeExecutiveSummaryTiles = hasBuildingFilterChanged(filterObjects);
        // if (!filterObjects?.filters || !filterObjects?.strat_year || !filterObjects?.end_year) {
        setSmartChartData("mfilter", {
            bandName: currentBand,
            entity: entity,
            removeWildcardFilter: !filterObjects?.filters,
            removeYearFilter: !filterObjects?.start_year || !filterObjects?.end_year,
            removeFilters: true,
            applyMasterToLocalFilter,
            removeExecutiveSummaryTiles
        });
        // }
        if (Object?.keys(filterObjects)?.length > 0 && !Object?.keys(filterObjects).every(item => item === "project_ids")) {
            Object?.keys(filterObjects)?.map(paramKeys => {
                const filterDetail = filterFields?.find(({ paramKey }) => paramKey === paramKeys);
                if (Object?.keys(filterObjects)?.length > 0) {
                    if (paramKeys === "exclude_filters") return;
                    let building_ids = [];
                    if (paramKeys === "building_types") {
                        building_ids = getSystemChartParams(filterObjects);
                    }
                    setSmartChartData("mfilter", {
                        mfilterKey: paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" ? "years" : paramKeys,
                        bandName: currentBand,
                        filterValues:
                            filterObjects[paramKeys]?.length > 0
                                ? paramKeys === "building_types"
                                    ? building_ids
                                    : [...filterObjects[paramKeys]]
                                : paramKeys === "start_year"
                                ? { start: filterObjects[paramKeys] }
                                : paramKeys === "end_year"
                                ? { end: filterObjects[paramKeys] }
                                : paramKeys === "update_fci"
                                ? { update_fci: filterObjects[paramKeys] }
                                : paramKeys === "project_cost"
                                ? { project_cost: filterObjects[paramKeys] }
                                : filterObjects[paramKeys],
                        entity: entity,
                        filterKey: paramKeys === "filters" ? "filters" : paramKeys === "top_n" ? "top_n" : filterDetail?.key,
                        dropDownData: dashboardMasterFilterList?.[filterDetail?.key] || [],
                        filterLabel:
                            paramKeys === "start_year"
                                ? "Start Year"
                                : paramKeys === "end_year"
                                ? "End Year"
                                : paramKeys === "update_fci"
                                ? "update_fci"
                                : paramKeys === "project_cost"
                                ? "Project Cost"
                                : paramKeys === "filters"
                                ? "filters"
                                : paramKeys === "top_n"
                                ? "top_n"
                                : filterDetail?.label,
                        isYearFilter: paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" || false,
                        paramKey:
                            paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" || paramKeys === "project_cost"
                                ? paramKeys
                                : "",
                        isFiltersKey: Object.keys(filterObjects?.filters || {})?.length > 0 ? "filterKey" : paramKeys === "top_n" ? "top_n" : "",
                        applyMasterToLocalFilter,
                        removeExecutiveSummaryTiles
                    });
                }
            });
        } else {
            setSmartChartData("mfilter", {
                bandName: currentBand,
                entity: entity,
                isFilterValue: true,
                applyMasterToLocalFilter,
                removeExecutiveSummaryTiles
            });
        }
        setConfirmationModal(false);
        setFilterOpen(false);
        setHeaderConfirmationModal(false);
        // setIsMasterFilterSubmit(false);
    };
    const renderConfirmationModal = () => {
        if (!confirmationModal) return null;

        const handleResponse = (shouldClear = false) => {
            const hasHeader = Array.isArray(chartSectionData?.custom_header_keys) && chartSectionData.custom_header_keys.length > 0;
            setClearLocalFilters(shouldClear);
            if (hasHeader) {
                setHeaderConfirmationModal(true);
                setConfirmationModal(false);
            } else {
                setConfirmationModal(false);
                setIsMasterFilterSubmit(temporaryMasterFilterData);
            }
        };
        const typeData = chartSectionData?.type || {};
        const keys = Object.keys(typeData);
        const hasExecutiveSummaryTile = keys.some(key => isExecutiveSummaryTile(key, typeData[key]));
        const hasRecommendation = keys.some(
            key => key.startsWith("multi_recommendation") || key.startsWith("normal_recom") || key.startsWith("recom_onepager")
        );
        const hasSystem = keys.some(key =>  key.startsWith("multisystem_") || key === "system");
        const affectedTileLabel =
            hasRecommendation && hasSystem ? "Recommendation & System" : hasSystem ? "System" : hasRecommendation ? "Recommendations" : "";
        const shouldWarnExecutiveSummary =
            confirmationModal === "executive_summary" || (hasExecutiveSummaryTile && hasBuildingFilterChanged(temporaryMasterFilterData));
        const isExecutiveSummaryOnlyWarning = shouldWarnExecutiveSummary && !affectedTileLabel;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            shouldWarnExecutiveSummary
                                ? isExecutiveSummaryOnlyWarning
                                    ? "Building filter change detected, the Executive Summary tiles will be removed."
                                    : "Changing the filter will apply the following changes:"
                                : `If the local Filters are applied in the ${confirmationModal === "system" ? "system" : confirmationModal === "all" ? "recommendation & system" : "recommendations"} tiles`
                        }
                        type="cancel"
                        message={
                            shouldWarnExecutiveSummary ? (
                                <div className="text-left">
                                    {isExecutiveSummaryOnlyWarning ? (
                                        <p className="mb-0 text-center">
                                            <b>Do you want to continue?</b>
                                        </p>
                                    ) : (
                                        <>
                                            <ul className="mb-3 pl-4">
                                                <li className="mb-2">Executive Summary tiles will be removed.</li>
                                                <li className="mb-2">
                                                    {affectedTileLabel} tiles with local filters applied may also be affected. Existing local filters
                                                    can cause data inconsistencies after the Master Filter change. In some cases, no data may be
                                                    displayed due to mismatched filters.
                                                </li>
                                            </ul>
                                            <div className="pt-2 mt-2 mb-3 mx-3 px-2 border-top">
                                                <p className="mb-0">
                                                    <b>Note:</b> Clicking "Yes" will clear the local filters from the tiles. Clicking "No" will keep
                                                    the local filters in the tiles. Executive Summary tiles will still be removed in both cases.
                                                </p>
                                            </div>
                                            <p className="mb-0 text-center">
                                                <b>Do you want to clear the local filters?</b>
                                            </p>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <p>
                                        Keeping these local filters after a Master Filter change may cause data inconsistencies or result in no data
                                        being displayed.
                                    </p>
                                    <p className="mb-0">
                                        <b>Do you want to clear Local Filters?</b>
                                    </p>
                                </>
                            )
                        }
                        onNo={() => {
                            if (isExecutiveSummaryOnlyWarning) {
                                setConfirmationModal(false);
                                setIsMasterFilterSubmit(false);
                                return;
                            }
                            handleResponse(false);
                        }}
                        onYes={() => handleResponse(true)}
                        onCloseModal={() => {
                            setConfirmationModal(false);
                            setIsMasterFilterSubmit(false);
                        }}
                    />
                }
                onCancel={() => {
                    setConfirmationModal(false);
                    setIsMasterFilterSubmit(false);
                }}
            />
        );
    };

    const renderHeaderConfirmationModal = () => {
        if (!headerConfirmationModal) return null;

        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading="Applying Master Filter will remove the current header configuration from this report."
                        type="cancel"
                        message={<b>Are you sure you want to proceed?</b>}
                        onNo={() => {
                            setHeaderConfirmationModal(false);
                            setClearLocalFilters(false);
                        }}
                        onYes={() => {
                            setIsMasterFilterSubmit(temporaryMasterFilterData);
                            setHeaderConfirmationModal(false);
                        }}
                        onCloseModal={() => {
                            setHeaderConfirmationModal(false);
                            setClearLocalFilters(false);
                        }}
                    />
                }
                onCancel={() => {
                    setHeaderConfirmationModal(false);
                    setClearLocalFilters(false);
                }}
            />
        );
    };
    const onFilterUpdate = filterObjects => {
        setTemporaryMasterFilterData(filterObjects);
        const typeData = chartSectionData?.type || {};
        const keys = Object.keys(typeData);

        if (!keys.length) {
            if (Array.isArray(chartSectionData?.custom_header_keys) && chartSectionData.custom_header_keys?.length > 0)
                setHeaderConfirmationModal(true);
            else setIsMasterFilterSubmit(filterObjects);
            return;
        }

        const hasRecommendation = keys.some(
            key => key.startsWith("multi_recommendation") || key.startsWith("normal_recom") || key.startsWith("recom_onepager")
        );

        const hasSystem = keys.some(key => key.startsWith("multisystem_") || key === "system");
        const hasExecutiveSummaryTile = keys.some(key => isExecutiveSummaryTile(key, typeData[key]));
        const buildingFilterChanged = hasBuildingFilterChanged(filterObjects);
        if (hasRecommendation && hasSystem) {
            setConfirmationModal("all");
        } else if (hasSystem) {
            setConfirmationModal("system");
        } else if (hasRecommendation) {
            setConfirmationModal(true);
        } else if (hasExecutiveSummaryTile && buildingFilterChanged) {
            setConfirmationModal("executive_summary");
        } else {
            if (Array.isArray(chartSectionData?.custom_header_keys) && chartSectionData.custom_header_keys?.length > 0) {
                setHeaderConfirmationModal(true);
            } else {
                setIsMasterFilterSubmit(filterObjects);
            }
        }
    };
    return (
        <>
            <div class="drag-main mt-2">
                <div class="row m-0">
                    {filteredData[entity]?.map((row, rowIndex) => (
                        <MasterFilter
                            getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                            masterFilterList={masterFilterList[entity]}
                            setSmartChartData={setSmartChartData}
                            currentBand={currentBand}
                            selectedFiltersList={chartSectionData?.mfilter}
                            selectedClient={selectedClient}
                            entity={entity}
                            rowIndex={rowIndex}
                            requiredFields={requiredFields}
                        />
                    ))}
                </div>
                <div class="row m-0">
                    <div class="col-md-12 p-0">
                        {rowConstructArray.map((dropRow, index) => (
                            <Droppable droppableId={`CHARTITEMS-${entity}-${index}`} direction="horizontal">
                                {(provided, snapshot) => (
                                    <div
                                        class="dragble-area"
                                        ref={provided.innerRef}
                                        {...provided.droppableProps} //new prop
                                        // isDraggingOver={snapshot.isDraggingOver}
                                    >
                                        {chartData
                                            // .filter(chartItem => chartItem.isVisible)
                                            .slice(index * 4, (index + 1) * 4)
                                            .map((item, i) => {
                                                return (
                                                    <Draggable
                                                        key={`draggable-${entity}-${i}${index}`}
                                                        draggableId={`draggable-${entity}-${i}${index}`}
                                                        index={index * 4 + i}
                                                        // index={i}
                                                    >
                                                        {provided => {
                                                            return (
                                                                <ChartItem
                                                                    index={i}
                                                                    provided={provided}
                                                                    item={item}
                                                                    setSmartChartData={setSmartChartData}
                                                                    currentBand={currentBand}
                                                                    openChartItemConfigModal={openChartItemConfigModal}
                                                                    droppableIndex={index}
                                                                    draggableIndex={i}
                                                                    entity={entity}
                                                                    toggleImageListForBandModal={toggleImageListForBandModal}
                                                                    toggleImageBandDeleteConfirmationModal={toggleImageBandDeleteConfirmationModal}
                                                                    editImageBand={editImageBand}
                                                                    isEdit={isEdit}
                                                                    updatePageBreakConfig={updatePageBreakConfig}
                                                                    isExcelExport={isExcelExport}
                                                                    isSkeletonView={isSkeletonView}
                                                                    buildingMfilter={chartSectionData?.mfilter?.building_ids}
                                                                    additionMfilter={chartSectionData?.mfilter?.addition_ids}
                                                                    siteMfilter={chartSectionData?.mfilter?.site_ids}
                                                                    currentChartData={chartSectionData}
                                                                    handleShowDocPreview={handleShowDocPreview}
                                                                    isPreviewDocLoading={isPreviewDocLoading}
                                                                    selectedDocPreview={selectedDocPreview}
                                                                    updateDocHeaderConfig={updateDocHeaderConfig}
                                                                    entireChartData={entireChartData}
                                                                    openExecutiveSummaryHierarchyConfig={openExecutiveSummaryHierarchyConfig}
                                                                />
                                                            );
                                                        }}
                                                    </Draggable>
                                                );
                                            })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        ))}
                    </div>
                </div>
                {/* </DragDropContext> */}
            </div>
            {filterOpen && isDataReady ? (
                <Portal
                    body={
                        <MyFilters
                            dashboardFilterParams={smartChartSectionData}
                            onCancel={() => setFilterOpen(false)}
                            submitMasterFilter={filterObjects => {
                                onFilterUpdate(filterObjects);
                            }}
                            yearValues={year}
                            isSmartChartFilter
                            filterName={smartChartFilterName}
                            filterCount={false}
                        />
                    }
                    onCancel={() => setFilterOpen(false)}
                />
            ) : null}
            {renderConfirmationModal()}
            {renderHeaderConfirmationModal()}
        </>
    );
};
export default ChartSection;
